<template>
  <div class="pill-scroller">
    <div class="pill-scroller__content">
      <div :class="pilClasses">
        {{ searchPillsTitle }}
      </div>
      <ul>
        <li v-for="search in searchPills" :key="search.id || search.slug">
          <nuxt-link :to="getSearchLink(search)">
            {{ search.display_name || search.name }}
          </nuxt-link>
        </li>
      </ul>
      <div v-if="savedSearches.length > 0" class="pill-scroller__more">
        <nuxt-link to="/cellar/saved/">Add More</nuxt-link>
      </div>
      <div v-if="personalizedSearches.length > 0" class="pill-scroller__more">
        <!-- top categories are not user editable, based on purchase history -->
      </div>
      <div v-else class="pill-scroller__more">
        <nuxt-link to="/store/">Shop all</nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
import { removeDomain } from '#common/components/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'PillScrollerSection',
  data() {
    return {
      showSavedSearchModal: false,
      personalizedSearches: [],
      commonSearches: [],
      savedSearches: [],
      searchPillsTitle: '',
      searchPills: [],
    }
  },
  computed: {
    ...mapGetters(['savedSearchList']),
    pilClasses() {
      const classes = ['pill-scroller__label']
      if (this.savedSearches.length > 0) {
        classes.push('has_saved_searches')
      }
      if (this.personalizedSearches.length > 0) {
        classes.push('has_recently_shopped')
      }
      return classes
    },
  },
  watch: {
    loggedIn(newStatus) {
      if (newStatus) {
        this.fetchData()
      }
    },
    $route(to, from) {
      if (to.path === '/' && from.path !== '/') {
        this.fetchTopCategoriesData()
      }
    },
  },
  mounted() {
    this.fetchTopCategoriesData()
    if (this.personalizedSearches) {
      const napaSearch = {
        slug: 'napa-valley-cabernet-sauvignon',
        display_name: 'Napa Cabernet',
      }
      if (!this.personalizedSearches.find((s) => s.slug === napaSearch.slug)) {
        this.personalizedSearches = this.personalizedSearches.concat([
          napaSearch,
        ])
      }
      const champSearch = {
        slug: 'champagne-sparkling',
        display_name: 'Champagne',
      }
      if (!this.personalizedSearches.find((s) => s.slug === champSearch.slug)) {
        this.personalizedSearches = this.personalizedSearches.concat([
          champSearch,
        ])
      }
      this.personalizedSearches = this.personalizedSearches.slice(0, 3)
    }
  },
  methods: {
    getSearchLink(search) {
      if (search.slug) {
        return `/store/${search.slug}/`
      } else if (search.link) {
        return removeDomain(search.link)
      }
      return false
    },
    async fetchTopCategoriesData() {
      try {
        const response = await this.$axios.get(
          'api/homepage/fetch-pill-scroller-data',
        )
        this.personalizedSearches = response.data.top_categories || []
        this.savedSearches = response.data.saved_searches || []
        this.commonSearches = response.data.common_searches || []

        this.searchPillsTitle = 'Common Searches'
        this.searchPills = []
        if ((this.savedSearches || []).length > 0) {
          this.searchPillsTitle = 'Saved Searches'
          this.searchPills = this.savedSearches // don't add anything to saved searches and don't limit them
        } else if ((this.personalizedSearches || []).length > 0) {
          this.searchPillsTitle = 'Recently Shopped'
          // if fewer than 3 top categories, add common searches to display 3 items
          this.searchPills = [
            ...this.personalizedSearches,
            ...this.commonSearches,
          ].slice(0, 3) // limit to 3 total
        } else {
          this.searchPills = this.commonSearches // use common searches only
        }
      } catch (error) {
        console.error('unable to fetch top categories data', error)
      }
    },
  },
}
</script>
